var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("message-box", {
    attrs: {
      "yes-no": _vm.schvalenieActionDialog.yesNo,
      title: _vm.schvalenieActionDialog.title,
      text: _vm.schvalenieActionDialog.text,
      action: _vm.schvalenieActionDialog.action,
      "hide-cancel": _vm.schvalenieActionDialog.hideCancel
    },
    model: {
      value: _vm.schvalenieActionDialog.open,
      callback: function($$v) {
        _vm.$set(_vm.schvalenieActionDialog, "open", $$v)
      },
      expression: "schvalenieActionDialog.open"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }